import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWireguardComponent } from './simple-icons-wireguard.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWireguardComponent ],
    exports:      [ SimpleIconsWireguardComponent ],
    bootstrap:    []
})
export class SimpleIconsWireguardModule {}
